import { useSpaceContext } from '../components/SpaceContextProvider';
export function useSpaceId() {
    const { spaceId } = useSpaceContext();
    return spaceId;
}
//# sourceMappingURL=use-space-id.js.map